<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Create Purchase Order</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/purchase-orders">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row dense id="po">
          <v-col cols="12" xs="12" sm="12" md="3">
            <v-autocomplete
              autocomplete="off"
              dense
              outlined
              v-model="record.SupplierId"
              :items="suppliers"
              label="Supplier"
              item-text="Name"
              item-value="id"
              :search-input.sync="searchSuppliers"
            >
              <template v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn class="ma-2" color="accent" dark small elevation="0" @click="openCreate()">
                    <v-icon left>mdi-plus</v-icon>Create A Supplier
                  </v-btn>
                </v-row>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="3">
            <v-text-field
              autocomplete="off"
              type="text"
              v-model="record.Title"
              outlined
              dense
              label="Title (Description)"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="3">
            <span
              v-if="dateReadonly == 'Y' && role != 3"
              style="font-weight: bold; font-size: 16px"
            >Date: {{ date }}</span>
            <DatePicker v-else @date="setDate" :myDate="date" :title="`Date`" ref="dateRef"></DatePicker>
          </v-col>

          <!-- add products -->
          <v-col cols="12">
            <v-btn text color="accent" @click="openModal">
              <v-icon>mdi-plus</v-icon>Add Product
            </v-btn>

            <v-data-table
              light
              dense
              :items-per-page="pageItems"
              :headers="headers"
              :items="orderItems"
              item-key="LineNum"
              hide-default-footer
              disable-sort
              :mobile-breakpoint="0"
              :calculate-widths="true"
            >
            <template v-slot:item.num="{ item, index }">
                <span>{{ index + 1 }}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <span style="margin-right: 15px !important">
                  {{
                  item.Quantity
                  }}
                </span>
              </template>

              <template v-slot:item.Price="{ item }">
                <span style="margin-right: 15px !important">
                  {{
                  item.Price.toLocaleString()
                  }}
                </span>
              </template>

              <template v-slot:item.DisplayTotal="{ item }">
                <span>{{ item.DisplayTotal.toLocaleString() }}</span>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
          <!-- end -->

          <v-col cols="12" xs="12" md="3">
            <span class="style-18">Total: {{ totalDisplayAmount | currency }}</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn
              small
              v-if="docCreate == true"
              color="primary"
              @click="sendData"
              :loading="$store.state.btnLoader"
            >
              <v-icon left>mdi-content-save</v-icon>Create LPO
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <!-- purchase dialog -->
          <v-dialog v-model="purchaseDialog">
            <v-card>
              <v-toolbar dense color="secondary" flat>
                <v-toolbar-title>Product Selection</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="purchaseDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row>
                    <v-col cols="12" xs="12" md="4">
                      <v-autocomplete
                        autocomplete="off"
                        dense
                        outlined
                        single-line
                        v-model="purchaseItem.id"
                        :items="products"
                        label="Select Product"
                        item-text="Name"
                        item-value="id"
                        @change="setOrderItem"
                        :search-input.sync="searchProducts"
                      >
                        <template v-slot:no-data>
                          <v-row align="center" justify="center">
                            <v-btn
                              :loading="searchingProduct"
                              class="ma-2"
                              color="accent"
                              dark
                              small
                              elevation="0"
                              @click="productModal()"
                            >
                              <v-icon left>mdi-plus</v-icon>Create A Product
                            </v-btn>
                          </v-row>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6" xs="6" md="6">
                      <v-text-field
                        autocomplete="off"
                        type="number"
                        v-model="purchaseItem.Quantity"
                        @input="qtyChanged(purchaseItem)"
                        label="Qty"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" xs="6" md="6">
                      <v-text-field
                        autocomplete="off"
                        type="text"
                        name="goodsReceiptUom"
                        filled
                        outlined
                        readonly
                        dense
                        value="Unit(s)"
                        v-if="purchaseItem.ManualStatus == 'Y'"
                      ></v-text-field>
                      <v-autocomplete
                        autocomplete="off"
                        v-else
                        dense
                        outlined
                        single-line
                        v-model="purchaseItem.UomEntry"
                        :items="purchaseItem.ugp1"
                        label="UOM"
                        item-text="UomName"
                        item-value="UomId"
                        @change="uomChanged(purchaseItem)"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" xs="12" md="12">
                      <v-text-field
                        autocomplete="off"
                        type="number"
                        v-model="purchaseItem.Price"
                        @input="qtyChanged(purchaseItem)"
                        label="Price"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12">Total: {{ purchaseItem.LineTotal | currency }}</v-col>

                    <v-col cols="12">
                      <v-btn color="accent" small @click="addProduct" :loading="loader">
                        <v-icon left>mdi-plus</v-icon>Add To List
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of products modal-->
        </v-row>
        <!-- snackbar -->
      </v-card-text>
    </v-card>

    <!-- Supplier quick add dialog -->
    <v-dialog v-model="supplierDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Create A Supplier</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="supplierDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <supplier-editor :initial="supplierItem" @data="saveSupplier"></supplier-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- product quick add dialog -->
    <v-dialog v-model="productDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create A Product</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="productDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <product-editor :docCreate="true" :initial="productItem" @data="saveProduct"></product-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
  
  
  <script>
import SupplierEditor from "@/components/subscriber/suppliers/_components/quick-editor.vue";
import ProductEditor from "@/components/subscriber/products/creation/_components/editor.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  name: "NewPurchaseOrder",
  components: {
    ProductEditor,
    SupplierEditor
  },
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    supplierDialog: false,
    supplierItem: {},
    productDialog: false,
    productItem: {},
    purchaseDialog: false,
    purchaseItem: {},
    taxGroups: [],
    selectedProduct: null,
    searchProducts: null,
    SumApplied: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentMode: null,
    searchSuppliers: null,
    accounts: [],
    orderItems: [],
    suppliers: [],
    products: [],
    stores: [],
    date: new Date().toISOString().substr(0, 10),
    todayDate: new Date().toISOString().substr(0, 10),
    dateReadonly: "",
    headers: [
      { text: "No.", value: "num" },
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Uom", value: "uomEntryName" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" }
    ]
  }),
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    balance() {
      let sum = 0;
      if (this.SumApplied) {
        sum = this.SumApplied;
      }
      return this.totalAmount - parseFloat(sum);
    },
    displayBalance() {
      let bal = 0;
      if (this.docCreate == true) {
        bal = this.balance.toLocaleString();
      } else {
        bal = this.record.Balance;
      }
      return bal;
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    },
    PaidSum() {
      let paid = 0;
      if (this.record.PaidSum) {
        paid = this.record.PaidSum.toLocaleString();
      }
      return paid;
    }
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true
    },
    searchSuppliers(val) {
      if (val && val !== this.select && this.querySuppliers(val)) {
        this.querySuppliers(val);
      }
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    }
  },
  methods: {
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }
    },
    saveProduct(data) {
        data.store_id = parseInt(this.activeStore);
      const url = "/products";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.productDialog = false;
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show("Product added Successfully", "green");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    productModal() {
      this.productDialog = true;
    },
    saveSupplier(data) {
      const url = "/suppliers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            const supplier = res.ResponseData;
            self.suppliers = [...this.suppliers, supplier];
            self.record.CardCode = supplier.id;
            self.$refs.snackbar.show("Supplier Added Successully", "green");
            self.supplierDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    openCreate() {
      this.supplierDialog = true;
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null && res.ResponseData.length > 0) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySuppliers(searchText) {
      const self = this;
      const url = "/suppliers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    openModal() {
      this.purchaseItem = {};
      this.purchaseItem.id = null;
      this.purchaseDialog = true;
    },
    uomChanged(item) {
      this.purchaseItem.Price = null;
      let ugp1 = [];
      ugp1 = item.ugp1;
      if (ugp1) {
        let ugp1Record = ugp1.find(record => {
          return record.UomEntry === item.UomEntry;
        });
        this.purchaseItem.uomEntryName = ugp1Record.UomName;
        this.purchaseItem.Price = ugp1Record.BuyingPrice;

        // update LineTotal
        var total = this.purchaseItem.Quantity * this.purchaseItem.Price;
        console.log(total);
        this.purchaseItem.LineTotal = total;
      }
    },
    qtyChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.purchaseItem.LineTotal = LineTotal;
      this.purchaseItem.DisplayTotal = DisplayTotal;
    },
    addProduct() {
      if (
        this.purchaseItem.Quantity == null ||
        this.purchaseItem.Price == null ||
        this.purchaseItem.id == null
      ) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
      } else {
        const self = this;
        const initArray = [];
        initArray.push(self.purchaseItem);
        self.orderItems = [...self.orderItems, ...initArray];
        this.purchaseItem = {};
        this.purchaseDialog = false;
      }
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/products/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            // current item definition
            let currentItem = {};
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.PUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            if (product.HasUom === 0) {
              // check if manual yes and assign
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = buyingPrice;
              currentItem.currentPrice = buyingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;

              this.select = null;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.PUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.Price = ugp1Record.BuyingPrice;
              currentItem.currentPrice = ugp1Record.BuyingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;
              this.select = "";
              self.products = [];
              // end of push
            }

            this.purchaseItem = { ...this.purchaseItem, ...currentItem };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    generateUniqueId() {
      var subscriberId = localStorage.getItem("subscriber_id");
      var date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      var dateString = `${year}-${month}-${day}`;
      var uniqueId = `${uuidv4()}-${dateString}-${subscriberId}`;
      return uniqueId;
    },
    sendData() {
      if (
        this.record.SupplierId == null ||
        this.record.SupplierId == undefined
      ) {
        this.$refs.snackbar.show("Please select supplier !", "red");
        return;
      }

      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.orderItems.length <= 0) {
        this.$refs.snackbar.show("You must have at least one product", "red");
        return;
      }

      var uniqueId = this.generateUniqueId();

      let saleDate = this.date;
      this.record = { ...this.record, DocDate: saleDate };
      const data = this.record;
      data.ObjType = 11;
      data.UniqueId = uniqueId;
      data.DocTotal = this.totalAmount;
      data.DocNum = this.DocNum;
      data.CreatedBy = this.UserSign;
      data.ref2 = this.ref2;
      var storeId = parseInt(this.activeStore);
      data.storeId = storeId;
      data.CreatedBy = parseInt(this.userSign);
      data.terms = this.terms;

      // append order rows
      var orderData = this.orderItems;

      var rows = [];
      for (const row of orderData) {
        var details = {
          productId: row.o_i_t_m_s_id,
          UomEntry: row.UomEntry,
          Quantity: parseFloat(row.Quantity),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          name: row.Name,
          storeId: storeId
        };

        rows.push(details);
      }
      // end

      data.rows = rows;

      // save data
      const url = "/create-lpo";
      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getDocNum();
            const NewDate = this.record.DocDate;
            self.record = {};
            self.record.DocDate = NewDate;
            if (self.clearDate == "Y") {
              this.$refs.dateRef.clearDate();
            }
            self.orderItems = [];
            self.SumApplied = 0;
            self.DiscOnTotal = 0;
            self.ref2 = null;
            self.UserSign = null;
            this.$refs.snackbar.show("Created successful", "green");
            self.$router.push("/purchase-orders");
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dateReadonly = res.ResponseData.dateReadonly;
            if (res.ResponseData.DefaultStockStore) {
              if (self.docCreate) {
                self.record.DocDate = new Date().toISOString().substr(0, 10);
              }
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/12`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (self.docCreate == true) {
              self.record = {
                ...self.record,
                DocNum: res.ResponseData.NextNumber
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([
      this.getAccounts(),
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum()
    ]);
  }
};
</script>
  
  <style  scoped>
/* .v-text-field__details {
    display: none !important;
  } */
</style>